const es = {
  _code: "es",
  Event0: "",
  Event1: "",
  Event2: "Botón activado",
  Event3: "Motor encendido",
  Event4: "Motor apagado",
  Event5: "Puerta abierta",
  Event6: "Puerta cerrada",
  Event7: "Válvula abierta",
  Event8: "Válvula cerrada",
  Event9: "Exceso de velocidad",
  Event10: "Batería baja (externa)",
  Event11: "Requiere comunicación",
  Event12: "Batería desconectada",
  Event13: "Batería Reconectada",
  Event14: "Arrastre de Vehículo",
  Event15: "Ralentí",
  Event16: "Conexión de caja",
  Event17: "Desconexión de caja",
  Event19: "Cofre abierto",
  Event20: "Cofre cerrado",
  Event21: "Entregado",
  Event22: "No entregado",
  Event23: "Batería baja (interna)",
  Event30: "Ahorro de energía",
  Event33: "Detección de interferencia",
  Event34: "Tamper ON",
  Event35: "Tamper OFF",
  Event36: "Mezclando",
  Event37: "Descarga",
  Event43: "Puerta lateral abierta",
  Event44: "Puerta lateral cerrada",
  Event47: "Conexión batería interna",
  Event48: "Desconexión batería interna",
  Event50: "Temperatura normal",
  Event51: "Temperatura baja",
  Event52: "Temperatura alta",
  Event53: "Presión normal",
  Event54: "Presión baja",
  Event55: "Presión alta",
  Event56: "Nivel normal",
  Event57: "Nivel bajo",
  Event70: "Inicio de ralentí",
  Event71: "Fin de ralentí",
  Event101: "Termo encendido",
  Event102: "Termo apagado",
  Event103: "Puerta principal abierta",
  Event104: "Puerta principal cerrada",
  Event105: "Carga de combustible",
  Event106: "Descarga de combustible",
  Event107: "Trasvase",
  Event108: "Conexión de sensor (1)",
  Event109: "Desconexión de sensor (1)",
  Event110: "Conexión de sensor (2)",
  Event111: "Desconexión de sensor (2)",
  Event120: "Servicio",
  Event130: "Inicio de exceso de velocidad",
  Event131: "Fin de exceso de velocidad",
  Event133: "Aceleración intensa",
  Event134: "Frenado intenso",
  Event136: "Giro brusco",
  Event137: "Curva con velocidad alta",
  Event139: "Impacto",
  Event140: "Colisión",
  Event142: "Exceso de tiempo continuo manejando",
  Event143: "Inicio de manejo fuera de horario",
  Event144: "Fin de manejo fuera de horario",
  Event159: "DTC eliminado",
  Event160: "DTC detectado",
  Event161: "Fuera de rango (RPM)",
  Event162: "Fuera de rango (Odómetro)",
  Event163: "Fuera de rango (Combustible - limite superior)",
  Event164: "Fuera de rango (Combustible - limite inferior)",
  Event165: "Fuera de rango (Posición del acelerador)",
  Event166: "Fuera de rango (Temperatura del anticongelante)",
  Event167: "Fuera de rango (Horómetro)",
  Event254: "Tiempo inmóvil acumulado",

  Month1: "Enero",
  Month2: "Febrero",
  Month3: "Marzo",
  Month4: "Abril",
  Month5: "Mayo",
  Month6: "Junio",
  Month7: "Julio",
  Month8: "Agosto",
  Month9: "Septiembre",
  Month10: "Octubre",
  Month11: "Noviembre",
  Month12: "Diciembre",

  Day1: "Domingo",
  Day2: "Lunes",
  Day3: "Martes",
  Day4: "Miércoles",
  Day5: "Jueves",
  Day6: "Viernes",
  Day7: "Sábado",

  Monday: "Lunes",
  Tuesday: "Martes",
  Wednesday: "Miercoles",
  Thursday: "Jueves",
  Friday: "Viernes",
  Saturday: "Sábado",
  Sunday: "Domingo",

  CombustibleCalculadoPorUnidad: "Combustible calculado por unidad",
  CombustibleCalculado: "Combustible calculado",
  RalentiPorFlota: "Ralentí por flota",
  Minutos: "Minutos",
  EstadoDeIgnicion: "Estado de ignición",
  Encendidas: "Encendidas",
  Apagadas: "Apagadas",
  EstadoDeMovimiento: "Estado de movimiento",
  Detenidas: "Detenidas",
  ProximoRecordatorio: "Próximo recordatorio",
  SinDatosAMostrar: "Sin datos a mostrar",
  RangoDeConsulta: "Rango de consulta",
  IntervaloDeActualizacion: "Intervalo de actualización",
  ActualizacionManual: "Actualización manual",
  Ajustes: "Ajustes",
  SinOrdenesDeTrabajo: "Sin ordenes de trabajo",
  OrdenesDeTrabajo: "Ordenes de trabajo",
  Activas: "Activas",
  Inactivas: "Inactivas",
  Neutral: "Neutral",
  EstadoDeConectividad: "Estado de conectividad",
  Valor: "Valor",
  Grafica: "Gráfica",
  Seleccionadas: "Seleccionadas",
  NoSeleccionadas: "No seleccionadas",
  SemanaEnCurso: "Semana en curso",
  SemanaPasada: "Semana pasada",

  AceleracionIntensa: "Aceleración intensa",
  AceleracionesIntensas: "Aceleraciones intensas",
  Anio: "Año",
  Anterior: "Anterior",
  AperturaPuertaLateral: "Puerta lateral abierta",
  AperturaPuertaPrincipal: "Puerta principal abierta",
  AplicarLimites: "Guardar",
  Atajo: "Atajo",
  Ayer: "Ayer",
  BateriaVehiculo: "Batería del vehículo",
  CambiarIdioma: "Change language to English (US)",
  CambiarRangos: "Configurar rangos",
  CambiarUnidadTemperaturaA: "Cambiar unidad de temperatura a",
  Cancelar: "Regresar",
  Cantidad: "Cantidad",
  CantidadDeServicios: "Cantidad de servicios",
  Cargando: "Cargando",
  CargasCombustible: "Cargas",
  CargasYDescargasFuel: "Cargas y descargas",
  CiclosRefrigeracion: "Ciclos de refrigeración",
  Ciudad: "Ciudad",
  Cliente: "Cliente",
  ClientesVisitados: "Clientes visitados",
  Codigo: "Código",
  CodigosError: "Codigos de error",
  Colision: "Colisión",
  Colisiones: "Colisiones",
  Combustible: "Combustible",
  CombustibleConsumido: "Combustible consumido",
  CombustibleDesviado: "Combustible desviado",
  CombustibleConsumidoDesviado: "Consumido/desviado",
  CombustibleRalenti: "Combustible en ralentí",
  CombustibleInicial: "Combustible inicial",
  CombustibleFinal: "Combustible final",
  CombustibleUtilizado: "Combustible utilizado",
  ComportamientoGeneral: "Comportamiento general",
  ConfiguracionDriving: "Configuración de driving",
  ConfigurarValores: "Configurar valores",
  ConfigurarRangosTemperatura: "Configurar rangos de temperatura",
  Consultar: "Consultar",
  ConsultaRapida: "Consulta rápida",
  Consumo: "Consumo",
  ConfiguracionGuardada: "Configuración guardada",
  Costo: "Costo",
  CostoDelCombustible: "Costo del combustible",
  De: "de",
  DescargarComo: "Descargar",
  DescargasCombustible: "Descargas",
  Descripcion: "Descripción",
  DescripcionPorUnidad: "Descripción por unidad",
  Descuento: "Descuento",
  Desgaste: "Desgaste",
  Desviacion: "Desviación",
  Detalles: "Detalles",
  Detenido: "Detenido",
  Direccion: "Dirección",
  Distancia: "Distancia",
  DistanciaRecorrida: "Distancia recorrida",
  DistribucionEventos: "Distribución de eventos",
  ErrorAlAplicarRangos: "Hubo un error al aplicar los rangos de temperatura",
  ErrorAlRestablecerRangos:
    "Hubo un error al restablecer los rangos de temperatura",
  ErrorAlCargarConfiguracionDriving:
    "There was an error loading the driving configuration",
  ErrorAlConsultarDatos: "Hubo un error al cargar los datos de la consulta",
  ErrorAlGuardarConfiguracion: "Hubo un error al guardar la configuración",
  Evento: "Evento",
  Eventos: "Eventos",
  EventosDeServicio: "Eventos de servicio",

  EventosDriving: " Histórico de eventos ",
  ExcesoVelocidad: "Exceso de velocidad",
  ExcesosVelocidad: "Excesos de velocidad",
  Fecha: "Fecha",
  FechaFinal: "Fecha final",
  FechaInicial: "Fecha inicial",
  Fin: "Fin",
  FrenadoIntenso: "Frenado intenso",
  FrenadosIntensos: "Frenados intensos",
  Fuga: "Fuga",
  GiroBrusco: "Giro brusco",
  GirosBruscos: "Giros bruscos",
  GraficaDeTemperaturas: "Gráfica de temperaturas",
  GraficaDeEventos: "Gráfica de eventos",
  Guardar: "Guardar",
  Historial: "Historial",
  Horometro: "Horómetro",
  Hoy: "Hoy",
  Icono: "Icono",
  Impacto: "Impacto",
  Impactos: "Impactos",
  Inicio: "Inicio",
  InicioHome: "Inicio",
  IntervalosFueraRango: "Intervalos fuera de rango",
  Kilos: "Kilos",
  KilosDespachados: "Kilos despachados",
  KilosLitrosDespachados: "Total despachado",
  LimiteInferior: "Límite inferior",
  LimiteSuperior: "Límite superior",
  Litros: "Litros",
  LitrosDespachados: "Litros despachados",
  LimiteCgu: "Límite CGU",
  LogOut: "Cerrar sesión",
  Mapa: "Mapa",
  Marca: "Marca",
  Maxima: "Máxima",
  Mediana: "Mediana",
  MejorCliente: "Mejor cliente",
  Minima: "Mínima",
  Modelo: "Modelo",
  Movimiento: "Movimiento",
  Muybien: "¡Muy bien!",
  Ninguno: "Ninguno",
  NivelCombustible: "Nivel del combustible",
  Nombre: "Nombre",
  NoSeEncontraronResultados: "No se encontraron resultados",
  Odometro: "Odómetro",
  Pagina: "Página",
  Personalizada: "Personalizada",
  Ponchaduras: "Ponchaduras",
  PosicionAcelerador: "Posición del acelerador",
  PrecioPorLt: "Precio por litro",
  PresionAceite: "Presión del aceite",
  PresionAlta: "Presión alta",
  PresionBaja: "Presón baja",
  Promedio: "Promedio",
  Puntos: "Puntos",
  PuntuacionPorUnidad: "Puntuación por unidad",
  Rango: "Rango",
  RangosDeTemperaturaAplicados: "Rangos de temperatura aplicados",
  RangosDeTemperaturaRestablecidos: "Rangos de temperatura restablecidos",
  RangoMaximoMayorARangoMinimo:
    "El límite superior debe ser mayor al límite inferior",
  Ralenti: "Ralentí",
  Rendimiento: "Rendimiento",
  RendimientoBruto: "Rendimiento bruto",
  RendimientoEfectivo: "Rendimiento efectivo",
  ReporteFinal: "Reporte final",
  ReporteInicial: "Reporte inicial",
  ReporteRendimiento: "Rendimiento",
  Restablecer: "Restablecer",
  Resultados: "resultados",
  Resumen: "Resumen",
  RestablecerRangos: "Restablecer rangos",
  ResumenComportamientoCombustible: "Resumen de comportamiento de combustible",
  Riesgo: "Riesgo",
  SemanaEnCurso: "Semana en curso",
  Sensores: "Sensores",
  SeleccioneAlMenosUnaUnidad: "Seleccione al menos una unidad para continuar",
  Servicios: "Servicios",
  Siguiente: "Siguiente",
  SinEventosDriving: "Tuviste un recorrido sin eventos",
  TemperaturaAceite: "Temperatura del aceite",
  TemperaturaAnticongelante: "Temperatura del anticongelante",
  TemperaturaCabina: "Temperatura en cabina",
  TemperaturaMaxima: "Temperatura máxima",
  TemperaturaMinima: "Temperatura mínima",
  TemperaturaPromedio: "Temperatura promedio",
  TermosEncendidos: "Termo encendido",
  Tiempo: "Tiempo",
  TiempoEnRefrigeracion: "Tiempo en refrigeración",
  TiempoFueraRango: "Tiempo fuera de rango",
  TiempoMovimiento: "Tiempo en movimiento",
  TiempoMuerto: "Tiempo muerto",
  TipoUnidad: "Tipo de unidad",
  Total: "Total",
  TotalServicios: "Total de servicios",
  TotalVenta: "Total de venta",
  Trayecto: "Trayecto",
  Trayectos: "Trayectos",
  Ultimos30Dias: "Últimos 30 días",
  Unidad: "Unidad",
  UnidadConMasServicios: "Unidad con más servicios",
  UnidadConMenosServicios: "Unidad con menos servicios",
  UnidadEstacionaria: "Unidad estacionaria",
  UnidadDeNoConsumo: "Unidad de no consumo",
  UnidadRegularDeConsumo: "Unidad regular de consumo",
  Unidades: "Unidades",
  Usuario: "Usuario",
  Valor: "Valor",
  ValoresPorDefecto: "Valores por defecto",
  Velocidad: "Velocidad",
  VelocidadMaxima: "Velocidad máxima",
  VelocidadMotor: "Velocidad del motor",
  VelocidadPromedio: "Velocidad promedio",
  VelocidadVehiculo: "Velocidad del vehículo",
  VentasConDescuento: "Ventas con descuento",
  Volumen: "Volumen",

  AppDashboard: "Dashboard",
  AppFuel: "Combustible",
  AppGas: "Gas",
  AppDriving: "Comportamiento de manejo",
  AppTemp: "Temperatura",
  AppScan: "Scan"
};

export default es;



// WEBPACK FOOTER //
// ./src/lang/es.js